import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Section from 'components/Section';
import SearchForm from 'components/SearchForm';
import SearchForEveryone from 'components/SearchForEveryone';
import config from 'config';
import './Home.css';
import texts from 'texts';
import { Helmet } from 'react-helmet';
import {
  handleDisplayFab,
  scrollToTop,
} from 'utils/commonTools';
import { changeLanguage } from 'actions/langActions';
import { setSearchFormFullScreen } from 'actions/searchFormFullScreenActions';
import Fab from '@mui/material/Fab';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { translation } from 'utils/translate';

const Home = () => {
  const { hash } = useLocation();
  const dispatch = useDispatch();

  const lang = useSelector((store) => store.lang);
  const fullScreen = useSelector((store) => store.searchFormFullScreen)

  const activeFormGlobal = useSelector((store) => store.docGroup)
  
  const searchState = useSelector((store) => store.searchState)

  const isSubmited = useSelector((store) => store.isSearchSubmited)


  useEffect(() => {
    // create a scroll listener that toggles the visibility of the Fab
    window.addEventListener('scroll', handleDisplayFab);
    // remove listener on unmount
    return () => window.removeEventListener('scroll', handleDisplayFab);
  }, []);

  useEffect(() => {
    //hashLinkScroll();

    if(window.location.search){
      if (window.location.search.includes("lang=se")){
        dispatch(changeLanguage("se"))
      }
    }
    else if(window.location.href.includes("#basic-search-term")){
        dispatch(setSearchFormFullScreen(false))
        if(isSubmited === true){
          dispatch(setSearchFormFullScreen(true))
        }
    }
    if(window.location.search === "?lang=se" || window.location.search === "?lang=fi"){
      if(isSubmited){
        dispatch(setSearchFormFullScreen(true))
      }
      else{
        dispatch(setSearchFormFullScreen(false))
      }
    }
  }, [hash, fullScreen, isSubmited, dispatch]);

  return (
    <>
      <Helmet>
        <title>Etusivu | {config.site.name}</title>
      </Helmet>
      <Fab
        variant="circular"
        size="medium"
        color="secondary"
        aria-label="add"
        className="fab-navigation fab-hide"
        onClick={() => scrollToTop()}
      >
        {/* <NavigationIcon /> */}
        <ArrowUpwardIcon />
      </Fab>
      {searchState === "yleinen" &&
       <>
          <div className='section-for-everyone'>
            <SearchForEveryone/>
          </div>
        </>
      }
      {searchState === "tutkija" &&
        <>
        <Section className="section--info-area">
          {fullScreen === false &&
            <div className="intro-info">
              <h1>{texts.info.intro_header[lang]}</h1>
              {texts.info.intro[lang]}
            </div>
          }
          {fullScreen &&
            <div className="search-result-title">
              <h1>{translation("Hakutulokset", lang)}</h1>
            </div>
          }  
        </Section>

        <Section className="section--content" role="main"> 
          <SearchForm docGroup={activeFormGlobal} />

        </Section>
        </>
      }
    </>
  );
};

export default Home;
